<mat-dialog-content class="content" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="5px">
  <p>{{ 'registration.error-registration' | translate }}</p>
</mat-dialog-content>
<mat-divider></mat-divider>
<mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]>OK</button>
</mat-dialog-actions>
